/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'alpinejs';
// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faSearch,faChevronLeft,faChevronRight);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();
import 'slick-carousel/slick/slick.min.js';

// Fix Passive Event Listener issue with Slick
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    if ( ns.includes("noPreventDefault") ) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ){
    if ( ns.includes("noPreventDefault") ) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  }
};

$(document).ready(() => {

    $('.slick-hero').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      speed: 2000,
      fade: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 1024,
          settings: {}
        },
        {
          breakpoint: 600,
          settings: {}
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    $('.slick-logos').slick({
      autoplay: false,
      autoplaySpeed: 1000,
      dots: true,
      arrows: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });

  jQuery(document).ready(function($) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 5) { 
        $('.header').addClass('shrink');
        $('a.brand').addClass('shrink');
      }
      else{
        $('.header').removeClass('shrink');
        $('a.brand').removeClass('shrink');
      }
    });
  });

});
